<vdr-ui-extension-point [locationId]="locationId" api="detailComponent"></vdr-ui-extension-point>
